const normalizeLanguage = (language) => {
  if (typeof language !== "string") return undefined;

  const trimmed = language.trim();
  if (!trimmed) return undefined;

  return trimmed.split(/[-_]/)[0]?.toLowerCase() || undefined;
};

const pad = (value) => String(value).padStart(2, "0");

export const formatBirthdayForGtm = (birthday) => {
  if (!birthday) return undefined;

  if (typeof birthday === "string") {
    const trimmed = birthday.trim();
    if (!trimmed) return undefined;

    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
      return trimmed;
    }

    const frenchDate = trimmed.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (frenchDate) {
      return `${frenchDate[3]}-${frenchDate[2]}-${frenchDate[1]}`;
    }
  }

  const parsed = new Date(birthday);
  if (Number.isNaN(parsed.getTime())) {
    return undefined;
  }

  return `${parsed.getFullYear()}-${pad(parsed.getMonth() + 1)}-${pad(parsed.getDate())}`;
};

const asArray = (value) => {
  if (Array.isArray(value)) return value;
  return value ? [value] : [];
};

const normalizeText = (value) => {
  if (typeof value !== "string") return undefined;
  const trimmed = value.trim();
  return trimmed || undefined;
};

const resolveFlyproNameFromEntry = (entry) => {
  if (!entry) return undefined;

  if (typeof entry === "string") {
    return normalizeText(entry);
  }

  const directName =
    normalizeText(entry?.extra?.full_name)
    || normalizeText(entry?.full_name)
    || normalizeText(entry?.name)
    || normalizeText(entry?.label);

  if (directName) {
    return directName;
  }

  const firstName = normalizeText(entry?.firstname || entry?.first_name);
  const lastName = normalizeText(entry?.lastname || entry?.last_name);

  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }

  return firstName || lastName;
};

export const resolveFlyproName = (flypros) => {
  const names = asArray(flypros)
    .map(resolveFlyproNameFromEntry)
    .filter(Boolean);

  if (!names.length) return undefined;

  return Array.from(new Set(names)).join(", ");
};

export const buildGtmEventFields = ({
  language,
  user,
  birthday,
  booking,
  flypros,
  flyproName,
} = {}) => {
  const fields = {
    language: normalizeLanguage(language),
    birthday: formatBirthdayForGtm(
      birthday ?? user?.birthdate ?? booking?.client?.birthdate
    ),
    flypro_name: normalizeText(flyproName)
      || resolveFlyproName(flypros)
      || resolveFlyproName(booking?.therapists),
  };

  return Object.fromEntries(
    Object.entries(fields).filter(([, value]) => value !== undefined)
  );
};
